import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { TaskDistrTaskByServiceModel } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class ApiTaskDistrTaskByServiceService extends ApiListDataService<
    TaskDistrTaskByServiceModel,
    TaskDistrTaskByServiceModel
> {
    constructor(http: HttpClient) {
        super(http, '/Task/DistrTaskByService/');
    }
}
